import { configureStore } from '@reduxjs/toolkit';

import rootReducer from 'pages/rootReducer';

const store = configureStore({
  reducer: rootReducer
});

export default store;
